import styled from "styled-components"


export const MarketingCampaignsListContainer = styled.ul`
  padding: 40px;
  margin: 0;
`

